import { request } from '@/shared/api/request'
export const getWorkerWelfare = (bin) =>
	request({ url: '/contract/universalMethods/requestAgrData?bin=' + bin, method: 'GET' })

export const getWorkerWelfareOPV = (bin) => request({ url: '/safety/getEmployeePortrait?bin=' + bin, method: 'GET' })
